// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"On-z","slideIn":"Pn-z"};